import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {X} from '@wix/wix-ui-icons-common'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import c from '../../../classnames.scss'
import s from '../coupon-input.scss'
import {CouponInputClearButtonProps} from '.'

export const CouponInputClearButton = ({onClick}: CouponInputClearButtonProps) => {
  const {t} = useTranslation()

  return (
    <button
      type="button"
      aria-label={t('a11y.clearCouponCodeButton')}
      data-hook={DH.COUPON_CODE_CLEAR}
      className={classNames(s.couponCancel, c.formSummaryCouponCancel)}
      onClick={onClick}
    >
      <X className={s.couponCancelIcon} size="17px" />
    </button>
  )
}
